import React from 'react';
import { Link } from 'react-router-dom';

const Pagination = ({ setCurpage, totalPage, page }) => {
	var pagesHtml = [];
	if (totalPage && totalPage > 5) {
		for (let i = 1; i < 6; i++) {
			pagesHtml.push(
				<li key={i}>
					<Link
						to='/#'
						className={i === page ? 'active' : ''}
						onClick={(e) => {
							e.preventDefault();
							setCurpage(i);
						}}
					>
						{i}
					</Link>
				</li>
			);
		}
	} else if (totalPage) {
		for (let j = 1; j <= parseInt(totalPage); j++) {
			pagesHtml.push(
				<li key={j}>
					<Link
						to='/#'
						className={j === page ? 'active' : ''}
						onClick={(e) => {
							e.preventDefault();
							setCurpage(j);
						}}
					>
						{j}
					</Link>
				</li>
			);
		}
	}

	return (
		<>
			{!isNaN(totalPage) && totalPage && totalPage !== 1 && (
				<div className='paginationComponent'>
					<div className='paginationSection'>
						<ul className='paginationUl'>
							{page && page !== 1 && (
								<li>
									<Link
										to='/#'
										onClick={(e) => {
											e.preventDefault();
											setCurpage(page - 1);
										}}
									>
										{'<'}
									</Link>
								</li>
							)}
							{pagesHtml}
							{totalPage && totalPage > 5 && (
								<li className='dotsPagenation'>
									<a href='/#'>...</a>
								</li>
							)}

							{totalPage && totalPage !== page && (
								<li>
									<Link
										to='/#'
										onClick={(e) => {
											e.preventDefault();
											setCurpage(page + 1);
										}}
									>
										{'>'}
									</Link>
								</li>
							)}
						</ul>
					</div>
				</div>
			)}
		</>
	);
};

export default Pagination;
